module.exports = __webpack_public_path__ + "img/whiteDown.b0b4be11.svg";